import { BaseEntity } from "yt-ng-framework";

export class EOtpremnicaPrevozView extends BaseEntity{
    constructor(){
        super();
    }

    BrojVoznje: number;
    PocetnaLokacijaPrevoznika: string;
    PretovarnaTackaPrevoznika: string; 
    ImeVozaca: string;
    PrezimeVozaca: string;
    TelefonVozaca: string; 
    PrevoznikNaziv: string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.BrojVoznje=input.BrojVoznje;
        this.PocetnaLokacijaPrevoznika=input.PocetnaLokacijaPrevoznika;
        this.PretovarnaTackaPrevoznika=input.PretovarnaTackaPrevoznika;
        this.ImeVozaca=input.ImeVozaca;
        this.PrezimeVozaca=input.PrezimeVozaca;
        this.TelefonVozaca=input.TelefonVozaca;
        this.PrevoznikNaziv = input.PrevoznikNaziv;
        return this;
    }

    Serialize(input:EOtpremnicaPrevozView){
        return input;
    }
}